import { jwtDecode } from 'jwt-decode';
import { StorageEnum } from './enum';

interface JwtPayload {
    sub: string;
    role?: string;
    exp: number;
}

/**
 * Decode JWT token and extract the role from the server-signed payload.
 * This is tamper-proof because modifying the token invalidates its signature,
 * causing the server to reject it with 401.
 */
export function getRoleFromToken(token?: string | null): string | null {
    const t = token ?? localStorage.getItem(StorageEnum.ACCESS_TOKEN);
    if (!t) return null;
    try {
        const decoded = jwtDecode<JwtPayload>(t);
        return decoded.role || null;
    } catch {
        return null;
    }
}

/**
 * Check if the current JWT token is expired.
 */
export function isTokenExpired(token?: string | null): boolean {
    const t = token ?? localStorage.getItem(StorageEnum.ACCESS_TOKEN);
    if (!t) return true;
    try {
        const decoded = jwtDecode<JwtPayload>(t);
        return decoded.exp * 1000 < Date.now();
    } catch {
        return true;
    }
}
